import {readApiModel} from '../../../helpers/api/apiHelpers';
import {CancelToken} from '../../../helpers/utilities/asyncCancelHelpers';
import {
  ApiStashLocalStorage,
  ApiStashServer,
  StashLocalStorageItems,
} from '../../../models/api/stash/stashModel';
import {fetchApiAsync} from '../../../services/http/http';
import {keyValueStore} from '../../../services/storage/storage';

/*
 * Local storage.
 */

export function buildStashLocalStorageKey(userId: number): string {
  return `com.front.stash.tea.${userId}`;
}

export function readStashFromLocalStorage(key: string): StashLocalStorageItems {
  const value = keyValueStore.read(key);
  if (!value) {
    return {};
  }

  return readApiModel(ApiStashLocalStorage, JSON.parse(value));
}

export function writeStashToLocalStorage(key: string, items: StashLocalStorageItems): void {
  const value = JSON.stringify(ApiStashLocalStorage.runtimeType.encode(items));
  keyValueStore.set(key, value);
}

/*
 * Server.
 */

export function buildStashUrl(companyUrl: string, userId: number): string {
  return `${companyUrl}/namespaces/tea:${userId}/stash`;
}

export type FetchStashFromServerOptions = {
  cancelToken?: CancelToken;
  signal?: AbortSignal;
};

export async function fetchStashFromServerAsync(url: string, options: FetchStashFromServerOptions = {}) {
  return fetchApiAsync(ApiStashServer, url, {
    cancelToken: options.cancelToken,
    signal: options.signal,
  });
}
